import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInstallments extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInstallments);
  }

  /**
   * Updates the installments block when the variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInstallments = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const selector = blockId ? `product-installments[data-block-id="${blockId}"]` : 'product-installments';
    const newInstallments = event.detail.data.html.querySelector(selector);

    if (!newInstallments) return;

    morph(this, newInstallments, { childrenOnly: true });
  };
}

if (!customElements.get('product-installments')) {
  customElements.define('product-installments', ProductInstallments);
}
